import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Modal } from '@dds-uicore/all'
import { ItemInfoModel } from 'src/app/model/item-info-model';
import { AgileSDKService } from 'src/app/services/agile-sdk.service';
@Component({
  selector: 'app-part-info-modal',
  templateUrl: './part-info-modal.component.html',
  styleUrls: ['./part-info-modal.component.css']
})
export class PartInfoModalComponent implements OnInit,AfterViewInit  {
  @ViewChild('triggerContainer') triggerContainer: ElementRef<HTMLElement>;
  @Input() modalId: string;
  @Input() modalTitleId: string;
  @Input() partNumber:string;
  partAttributes:ItemInfoModel = new ItemInfoModel();
  constructor(private aglService:AgileSDKService) { }
  ngAfterViewInit(): void {
    // throw new Error('Method not implemented.');
    const content = this.triggerContainer.nativeElement;
    if (content) {
      // If the modal-trigger ngcontent is plain text then we want to work with the contentContainer.
        // If otherwise modal-trigger ngcontent has one or more tags we want to work with the first child of contentContainer.
        const actualContent = (content.children) ? content.children[0] : content;
        // This two attributes are needed by @dds-uicore Modal
        actualContent.setAttribute('data-toggle', 'dds__modal');
        actualContent.setAttribute('data-target', `#${this.modalId}`);
        const thisModal = new Modal(actualContent);
        
      }
  }

  ngOnInit(): void {
    this.modalId = `${this.modalId}-modal-${this.Uuid()}`;
    this.modalTitleId = `${this.modalTitleId}-modal-${this.Uuid()}`;
    this.getPartDetails(this.partNumber);
  }
  Uuid() {
    const windowObj: any = window;
    const winCrypto = windowObj.crypto || windowObj.msCrypto;
    let index = winCrypto.getRandomValues(new Uint32Array(1))[0];
    index = +`${index}`.substr(0, 1);
    const uuid = winCrypto.getRandomValues(new Uint32Array(10))[index];
    return uuid;
  }
  getPartDetails(partNumber:string){
    console.log('Getting Part Details')
    this.aglService.getPartAttributeInfo(partNumber).subscribe((itemInfo) => {
      this.partAttributes = itemInfo;
    });
  }
}
